// extracted by mini-css-extract-plugin
export default {"dlReportSummaryItem":"src-js-containers-reports-components-ReportSummaryItem---dlReportSummaryItem---6JVbr"};